import Step1 from './step1/step1';
import Step2 from './step-2/Step2';
import Step3 from './step-3';
import Step4 from './step-4/Step4';

export {
  Step1,
  Step2,
  Step3,
  Step4,
};